import { IPage } from "../../shared/components/definitions/page/IPage";
import { MonitoreoReporteContentRender } from "../../shared/components/modulos/monitoreo/sesion/reporte/MonitoreoReporteContentRender";
import { serviceProvider } from "../../shared/comun/provider/ServiceProvider";
import { APP_RUTA_MONITOREO_PLAGAS } from "../components/ClienteModulesComponent";

/** Página del informe semanal de monitoreo (`/monitoreo/reporte`), con selector
 *  de año y semana.
 *
 *  **No tiene ítem de menú**: se llega desde el botón de informe de una semana
 *  del sidebar del mapa y desde "Ver informes" del dashboard. Por eso el botón
 *  volver lleva al **mapa** y no a la finca: se vuelve por donde se entró.
 *
 *  Muestra el mismo documento que la exportación imprimible, embebido — no una
 *  segunda versión del reporte. Full-width, sin segundo sidebar. */
export class MonitoreoReportePage implements IPage {
  render(pageContent: HTMLDivElement): void {
    this._content = new MonitoreoReporteContentRender(() =>
      serviceProvider.getLayoutService().navigate(APP_RUTA_MONITOREO_PLAGAS),
    );
    pageContent.innerHTML = this._content.render();
    this._content.connect();
  }

  dispose(): void {
    this._content?.dispose();
    this._content = null;
  }

  /** Contenido vivo de la página. */
  private _content: MonitoreoReporteContentRender | null = null;
}
